// src/utils/typeGuards.ts
import dayjs from "dayjs";

/**
 * 値が有効なフィールド値かどうかをチェックする型ガード関数
 */
export const isValidFieldValue = (value: any): value is string | number | boolean | null | undefined => {
    return (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        value === null ||
        value === undefined
    );
};

/**
 * 値が有効な日付文字列かどうかをチェックする型ガード関数
 */
export const isValidDateValue = (value: any): value is string => {
    return typeof value === 'string' && dayjs(value).isValid();
};